import React, { useState } from "react";
import {
  Typography,
  TextField,
  Chip,
  Box,
} from "@material-ui/core";

const ChipInput = ({ label, values, onChange, placeholder, helperText }) => {
  const [input, setInput] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const addValue = (value) => {
    if (!value.trim()) return;
    onChange([...values, value.trim()]);
    setInput("");
    setShowDropdown(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);
    setShowDropdown(!!value.trim());
  };

  const handleInputFocus = () => {
    // Show dropdown if there's text when focused
    if (input.trim()) {
      setShowDropdown(true);
    }
  };

  const handleInputBlur = () => {
    // Clear input and hide dropdown when focus is lost
    setTimeout(() => {
      setShowDropdown(false);
      setInput(""); // Clear the input value
    }, 200);
  };

  const handleDropdownClick = () => {
    addValue(input);
  };

  const canAddValue = input.trim() && !values.includes(input.trim());

  console.log("input", input, values);

  return (
    <Box mb={2}>
      <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8, color: "#555" }}>
        {label}
      </Typography>

      <Box style={{ position: 'relative', zIndex: 1 }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder={placeholder}
          value={input}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onKeyDown={(e) => e.key === "Enter" && canAddValue && addValue(input)}
          style={{ marginBottom: 8 }}
        />

        {showDropdown && canAddValue && (
          <Box
            style={{
              position: 'absolute',
              top: '40px',
              left: 0,
              right: 0,
              border: "1px solid #e0e0e0",
              borderRadius: 4,
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              zIndex: 9999,
            }}
          >
            <Box
              px={2}
              py={1.5}
              style={{
                cursor: "pointer",
                borderRadius: '4px',
                backgroundColor: isHovered ? 'var(--bg-canvas)' : '#fff',
              }}
              onClick={handleDropdownClick}
              onMouseDown={(e) => e.preventDefault()}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Add "{input.trim()}"
              </Typography>
            </Box>
          </Box>
        )}
      </Box>

      {helperText && (
        <Typography variant="caption" color="textSecondary" style={{ fontSize: '0.75rem', marginBottom: 8 }}>
          {helperText}
        </Typography>
      )}

      <Box display="flex" flexWrap="wrap" gap={4} mt={1}>
        {values.map((v) => (
          <Chip
            key={v}
            label={v}
            onDelete={() => onChange(values.filter((x) => x !== v))}
            size="small"
            color="primary"
            variant="outlined"
          />
        ))}
      </Box>
    </Box>
  );
};

export default ChipInput;